import React, { createContext } from 'react';
import PropTypes from 'prop-types';
import { notification } from 'antd';
import authService from 'services/auth.services';
import roleService from 'services/role.services';
import { storage } from 'helpers';

export const AuthContext = createContext();

export class AuthProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentUser: null,
      currentUserMerchs: null,
      selectedMerch: null,
      loading: false,
      authorities: null,
    };
  }

  componentDidMount() {
    this.updateCurrentUser();
    this.getAuthorities();
  }

  updateCurrentUser = async () => {
    try {
      this.setState({ loading: true });
      const token = storage.getToken();
      const response = await authService.getCurrentUser(token);
      const currentUser = response?.payload;
      const currentUserMerchs = currentUser?.merchantInfos;
      const selectedMerch = storage.get('selectedMerch')
        ? storage.get('selectedMerch')
        : currentUserMerchs[0];
      storage.set(selectedMerch, 'selectedMerch');
      storage.setUserInfo(currentUser);
      this.setState({
        currentUser,
        currentUserMerchs,
        selectedMerch,
        loading: false,
      });
    } catch (error) {
      this.setState({ loading: false });
      notification.error({
        message: 'Bir hata oluştu.',
        description: error,
      });
    }
  };

  getAuthorities = async () => {
    try {
      const { payload } = await roleService.getAuthorities();
      this.setState({ authorities: payload });
    } catch (error) {
      notification.error({
        message: 'Bir hata oluştu.',
        description: error,
      });
    }
  };

  changeSelectedMerch = (selectedMerch) => {
    storage.set(selectedMerch, 'selectedMerch');
    this.setState({ selectedMerch });
  };

  getContextValue = () => {
    return {
      ...this.state,
      updateCurrentUser: this.updateCurrentUser,
      changeSelectedMerch: this.changeSelectedMerch,
    };
  };

  render() {
    const { currentUser } = this.state;
    if (!currentUser) return null;

    const { children } = this.props;

    return <AuthContext.Provider value={this.getContextValue()}>{children}</AuthContext.Provider>;
  }
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
